import { create } from '@bufbuild/protobuf'
import { type ConnectError, type Transport } from '@connectrpc/connect'
import { createConnectQueryKey, useQuery } from '@connectrpc/connect-query'
import { listProcurementPlanAutoResubmitSettings } from '@ebalance/proto/bffuser/v1/plan_auto_resubmit_setting_service-PlanAutoResubmitSettingService_connectquery'
import {
  ListProcurementPlanAutoResubmitSettingsRequestSchema,
  type ListProcurementPlanAutoResubmitSettingsResponse,
} from '@ebalance/proto/bffuser/v1/plan_auto_resubmit_setting_service_pb'
import type { QueryKey, UseQueryResult } from '@tanstack/react-query'

const LIST_REQUEST = create(
  ListProcurementPlanAutoResubmitSettingsRequestSchema,
  {},
)

/**
 * `useListProcurementPlanAutoResubmitSettings` と同じ cache の key。 保存の応答で
 * cache を書き換える時に使う。 setQueryData は完全一致なので input と transport を
 * useQuery と同じに揃える (`BalanceImputationPolicy/hooks/useImputationPolicy.ts` 参照)。
 */
export function autoResubmitSettingsQueryKey(transport: Transport): QueryKey {
  return createConnectQueryKey({
    schema: listProcurementPlanAutoResubmitSettings,
    input: LIST_REQUEST,
    transport,
    cardinality: 'finite',
  })
}

/**
 * 需要調達計画の自動再提出の設定 20 単位を取得する (AC-PAR-001 / 010)。
 *
 * - throwOnError=false: 取得失敗は画面全体の error boundary ではなく、 モーダルの
 *   Alert と「再読み込み」で扱う (AC-PAR-010)。 再試行は共通の query の方針に任せる
 * - gcTime=0: モーダルを閉じると cache を捨て、 開くたびに取得中から始める。 前回開いた
 *   時の値を取得中に出すと、 他のユーザーの変更前の値を確定値のように見せてしまう
 *   (取得中は未確定として扱う。 AC-PAR-010)
 */
export function useListProcurementPlanAutoResubmitSettings(): UseQueryResult<
  ListProcurementPlanAutoResubmitSettingsResponse,
  ConnectError
> {
  return useQuery(listProcurementPlanAutoResubmitSettings, LIST_REQUEST, {
    throwOnError: false,
    gcTime: 0,
  })
}
